import { Link } from "@tanstack/react-router";
import salonHaircut from "@/assets/treatments/salon-haircut.jpg";
import { Section } from "@/components/layout/section";
import { Button } from "@/components/ui/button";

function ForPros() {
  return (
    <div className="bg-linear-to-b from-paper to-electric-50">
      <Section width="wide" id="pros" className="scroll-mt-24 py-10 md:py-12">
        <div className="grid items-center gap-8 md:grid-cols-2 md:gap-16">
          <div className="flex max-w-[440px] flex-col items-start gap-6">
            <h2 className="text-balance font-display text-[32px] font-bold leading-tight tracking-tight text-ink md:text-[44px]">
              List your salon on Slotique
            </h2>
            <Button asChild size="lg">
              <Link to="/onboarding/start" className="no-underline">
                List your salon
              </Link>
            </Button>
          </div>
          <img
            src={salonHaircut}
            alt=""
            width={1200}
            height={800}
            loading="lazy"
            decoding="async"
            className="aspect-[8/5] w-full rounded-sm object-cover md:max-w-[400px] md:justify-self-end"
          />
        </div>
      </Section>
    </div>
  );
}

export { ForPros };
